import { makeAutoObservable } from "mobx";

// ─── Submit-стор: флаг сохранения + модалка об успехе ────────────────────────

export class LegalSubmitStore {
  isSaving = false;
  showSuccessModal = false;

  constructor() {
    makeAutoObservable(this);
  }

  closeSuccessModal = () => {
    this.showSuccessModal = false;
  };

  reset = () => {
    this.isSaving = false;
    this.showSuccessModal = false;
  };
}
